module.exports = __webpack_public_path__ + "img/ApprovalForms.67e5bb44.svg";